// import { darken } from "../utils.js";

export const PIVOT = {
  //caption added
  "Pivot.Title.Bg.Color": {
    ref: "Color.Transparent"
  },
  "Pivot.Title.Padding.Top": {
    defaultValue: "0px"
  },
  "Pivot.Title.Padding.Right": {
    defaultValue: "0px"
  },
  "Pivot.Title.Padding.Bottom": {
    defaultValue: "0px"
  },
  "Pivot.Title.Padding.Left": {
    defaultValue: "0px"
  },
  "Pivot.Title.Font.Size": {
    ref: "Font.Size.16"
  },
  "Pivot.Title.Color": {
    ref: "Color.Gray.800"
  },
  "Pivot.Title.Font.Weight": {
    ref: "Font.Weight.SemiBold"
  },

  "Pivot.Grandtotal.Bg.Color": {
    ref: "Color.Transparent"
  },
  "Pivot.Grandtotal.Color": {
    ref: "Table.Row.Color"
  },
  "Pivot.Grandtotal.Font.Weight": {
    ref: "Font.Weight.SemiBold"
  },
  "Pivot.Header.Filter.Padding.Left": {
    ref: "Space.8"
  },
  "Pivot.Header.Filter.Padding.Right": {
    ref: "Space.8"
  },
  "Pivot.Header.Filter.Padding.Top": {
    ref: "Space.4"
  },
  "Pivot.Header.Filter.Padding.Bottom": {
    ref: "Space.4"
  },
  "Pivot.Header.Filter.Bg.Color": {
    ref: "Color.Gray.100"
  },
  "Pivot.Header.Filter.Color": {
    ref: "Table.Header.Color"
  },
  "Pivot.Header.Filter.Font.Weight": {
    ref: "Font.Weight.SemiBold"
  },
  "Pivot.Header.Filter.Border.Color": {
    ref: "Color.Transparent"
  },
  "Pivot.Header.Filter.Border.Left.Width": {
    defaultValue: "0px"
  },
  "Pivot.Header.Filter.Border.Right.Width": {
    defaultValue: "0px"
  },
  "Pivot.Header.Filter.Border.Top.Width": {
    defaultValue: "0px"
  },
  "Pivot.Header.Filter.Border.Bottom.Width": {
    defaultValue: "0px"
  },
  "Pivot.Icon.Dark.Gray": {
    ref: "Color.Gray.700"
  },
  "Pivot.Header.Color": {
    ref: "Table.Header.Color"
  },
  "Pivot.Header.Font.Size": {
    ref: "Table.Header.Font.Size"
  },
  "Pivot.Table.Header.Bg.Color": {
    ref: "Table.Header.Bg.Color"
  },
  "Pivot.Header.Font.Weight": {
    ref: "Font.Weight.SemiBold"
  },
  "Pivot.Row.Font.Size": {
    ref: "Table.Row.Font.Size"
  },
  "Pivot.Row.Font.Weight": {
    ref: "Font.Weight.Regular"
  },
  "Pivot.Row.Line.Height": {
    ref: "Table.Row.Line.Height"
  },
  "Pivot.Row.Letter.Spacing": {
    ref: "Table.Row.Letter.Spacing"
  },
  "Pivot.Row.Padding.Left": {
    ref: "Space.12"
  },
  "Pivot.Row.Padding.Right": {
    ref: "Space.12"
  },
  "Pivot.Row.Padding.Top": {
    ref: "Space.12"
  },
  "Pivot.Row.Padding.Bottom": {
    ref: "Space.12"
  },
  "Pivot.Row.Border.Color": {
    ref: "Table.Row.Border.Color"
  },
  "Pivot.Table.Header.Border.Color": {
    ref: "Color.Gray.400"
  },
  "Pivot.Table.Header.Border.Width": {
    ref: "Table.Row.Border.Width"
  },

  "Pivot.Row.Color": {
    ref: "Color.Gray.800"
  },

  //pivot view

  "Pivot.Bg.Color": {
    ref: "Color.White"
  },

  "Pivot.Overflow": {
    defaultValue: "auto"
  },

  "Pivot.Height": {
    defaultValue: "500px"
  },
  "Pivot.Width": {
    defaultValue: "100%"
  },
  "Pivot.Min.Height": {
    defaultValue: "300px"
  },
  "Pivot.Min.Width": {
    defaultValue: "750px"
  },
  "Pivot.Max.Height": {
    defaultValue: "unset"
  },
  "Pivot.Max.Width": {
    defaultValue: "unset"
  },

  "Pivot.Margin.Top": {
    defaultValue: "0px"
  },
  "Pivot.Margin.Right": {
    defaultValue: "0px"
  },
  "Pivot.Margin.Bottom": {
    defaultValue: "0px"
  },
  "Pivot.Margin.Left": {
    defaultValue: "0px"
  },

  "Pivot.Padding.Top": {
    defaultValue: "0px"
  },
  "Pivot.Padding.Right": {
    defaultValue: "0px"
  },
  "Pivot.Padding.Bottom": {
    defaultValue: "0px"
  },
  "Pivot.Padding.Left": {
    defaultValue: "0px"
  },

  "Pivot.Border.Style": {
    defaultValue: "solid"
  },
  "Pivot.Border.Color": {
    ref: "Color.Transparent"
  },

  "Pivot.Border.Left.Width": {
    defaultValue: "0px"
  },
  "Pivot.Border.Right.Width": {
    defaultValue: "0px"
  },
  "Pivot.Border.Top.Width": {
    defaultValue: "0px"
  },
  "Pivot.Border.Bottom.Width": {
    defaultValue: "0px"
  },

  "Pivot.Border.Top.Left.Radius": {
    defaultValue: "0px"
  },
  "Pivot.Border.Top.Right.Radius": {
    defaultValue: "0px"
  },
  "Pivot.Border.Bottom.Right.Radius": {
    defaultValue: "0px"
  },
  "Pivot.Border.Bottom.Left.Radius": {
    defaultValue: "0px"
  },

  "Pivot.Shadow": {
    defaultValue: "none"
  },
  "Pivot.Shadow.Type": {
    defaultValue: "none"
  },
  "Pivot.Shadow.Color": {
    ref: "Color.Shadow"
  }
};
